export enum EnumTpAutenticacaoConvenio {
    Titular = 0,
    Dependente = 1,
}